export interface ICertificatePublicInfo extends IMessageBody {
}

export interface ICommandMessage {
    body?: IMessageBody;

    cmd: string;

    id: string;
}

export interface ICreateStream extends IMessageBody {

    streamId?: string;

    name: string;

    mimeType: string;

    uri?: string;

    hash?: string;

    hashType?: string;
}

export interface IDecKeyResult {
    error: IErrorResult;

    key: string;

    keyId: string;
}

export interface IDecryptedKeys extends IMessageBody {
    keys: IDecKeyResult[];
}

export interface IErrorResult extends IMessageBody {
    message: string;

    type: string;
}

export interface IKeyDef {
    key: string;

    keyId: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IMessageBody {
}

export interface IMessageEnvelope {
    request?: ICommandMessage;

    response?: IResultMessage;

    sessionId: string;

    source?: string;

    responseSource?: string;
}

export interface IOpenSession extends IMessageBody {
    lang: string;
}

export interface IProviderInfo {
    settings?: any;

    type: string;

    version: string;

    /** Objekt umožňující specifikovat parametry pro předvýběr/filtrování podpisového certifikátu */
    selectionParams?: ISelectionParams;
}

/**
 * Objekt umožňující specifikovat parametry pro předvýběr/filtrování podpisového certifikátu
 * @includeToDoc
 */
export interface ISelectionParams {
    /** Identifikátor klíče autority (KeyID) */
    readonly authorityKeyIdentifier?: string;

    /**
     * Přepínač určující, zda se jedná o automatický výběr certifikátu nebo jen filtrování certifikátů v GUI
     * Filtrování v GUI zatím neimplementováno, příznak musí být vždy false
     */
    readonly isFilterForGui?: boolean;

    /** Identifikace vystavitele certifikátu ve tvaru `CN=DEMO PostSignum Qualified CA 4, O="Česká pošta, s.p.", C=CZ` */
    readonly issuerDN?: string;

    /** Sériové číslo certifikátu */
    readonly serialNumber?: string;

    /** Kryptografický otisk certifikátu */
    readonly thumbprint?: string;

    /** Algoritmus kryptografického otisku certifikátu */
    readonly thumbprintAlgorithm?: DigestAlgorithm;
}

/** Hašovací funkce */
export enum DigestAlgorithm {
    // hodnoty jsou ekvivalentní s SB_ALGORITHM_DGST_xxx ze SBConstants
    SHA1 = 28929,
    MD5 = 28930,
    MD2 = 28931,
    SHA256 = 28932,
    SHA384 = 28933,
    SHA512 = 28934,
    SHA224 = 28935,
    MD4 = 28936,
    RIPEMD160 = 28937,
    CRC32 = 28938,
    SSL3 = 28939,
    GOST_R3411_1994 = 28940,
    WHIRLPOOL = 28941,
    POLY1305 = 28942,
    SHA3_224 = 28943,
    SHA3_384 = 28944,
    SHA3_512 = 28945,
    SHA3_256 = 28946,
    BLAKE2S_128 = 28947,
    BLAKE2S_160 = 28948,
    BLAKE2S_224 = 28949,
    BLAKE2S_256 = 28950,
    BLAKE2B_160 = 28951,
    BLAKE2B_256 = 28952,
    BLAKE2B_384 = 28953,
    BLAKE2B_512 = 28954,
    SHAKE_128 = 28955,
    SHAKE_256 = 28956,
    SHAKE_128_LEN = 28957,
    SHAKE_256_LEN = 28958,
}

export interface IResultMessage {
    body?: IMessageBody;

    resultId?: string;

    /**
     * Textová reprezentace enumu ResultType
     */
    resultType: string;
}

export interface ISignedStreams extends IMessageBody {
    signedGroups: ISignStreamResults[];
}

export interface ISignParams {
    groupId: string;

    provider: IProviderInfo;
    streams: IStreamInfo[];
}

export interface ISignStreamResult {
    streamId: string;

    signedStreamId?: string;

    error?: IErrorResult;
}

export interface ISignStreamResults {
    groupId: string;

    signedStreams: ISignStreamResult[];
}

export interface ISignStreams extends IMessageBody {
    signGroups: ISignParams[];
}

export interface IStream extends IMessageBody {
    streamId: string;
}

export interface IStreamBlockRequest extends IMessageBody {
    length: number;
    streamId: string;
    encoding: string;
}

export interface IStreamData extends IMessageBody {
    data: string;

    /**
     * Textová reprezentace enumu TransferEncoding
     */
    encoding: string;

    isEnd: boolean;

    length: number;

    streamId: string;
}

export interface IStreamHash extends IMessageBody {
    streamHash: string;
}

export interface IStreamHashRequest extends IMessageBody {
    hashType: string;

    streamId: string;
}

export interface IStreamInfo {
    /**ID zobrazovaného streamu*/
    displayedStream: string;

    /**ID podepisovaného streamu*/
    signingStream: string;

    /**
    * Obsahuje aktuální podpis. Pokud je prázdný vytváří se podpis přímo z signingStream. Jinak se vytváří kontrapodpis
    * ASIC a PADES providery tento parametr nepoužívají, zjišťují přítomnost podpisu přímo v dodaném signingStream
    */
    currentSignatureStream?: string;
}

export interface IStreamSize extends IMessageBody {
    streamSize: number;
}

export interface IVersionInfo extends IMessageBody {
    version: string;
    platform: string;
}
